import * as React from 'react';

function Calm(props) {
	return (
		<svg
			width="60"
			height="60"
			viewBox="0 0 60 60"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M29.9999 59.9999C46.5685 59.9999 59.9999 46.5685 59.9999 29.9999C59.9999 13.4314 46.5685 0 29.9999 0C13.4314 0 0 13.4314 0 29.9999C0 46.5685 13.4314 59.9999 29.9999 59.9999Z"
				fill="#83CDF5"
			/>
			<path
				opacity="0.5"
				d="M36.4286 55.5709C19.8601 55.5709 6.42875 42.1396 6.42875 25.5711C6.42875 16.7192 10.2633 8.76393 16.3612 3.27267C6.64894 8.23858 0 18.3427 0 29.9998C0 46.5683 13.4314 59.9996 29.9998 59.9996C37.7165 59.9996 44.7517 57.0852 50.0672 52.2984C45.9753 54.3905 41.34 55.5709 36.4286 55.5709Z"
				fill="#3A79B9"
			/>
			<path
				d="M28.8163 21.9341C28.1422 21.9341 27.5959 21.3877 27.5959 20.7137C27.5959 19.1396 26.315 17.8588 24.741 17.8588C23.1669 17.8588 21.8861 19.1397 21.8861 20.7137C21.8861 21.3878 21.3396 21.9341 20.6657 21.9341C19.9916 21.9341 19.4453 21.3877 19.4453 20.7137C19.4453 17.7937 21.8209 15.4181 24.741 15.4181C27.6611 15.4181 30.0367 17.7937 30.0367 20.7137C30.0368 21.3877 29.4903 21.9341 28.8163 21.9341Z"
				fill="#3A79B9"
			/>
			<path
				d="M49.4296 21.9341C48.7555 21.9341 48.2092 21.3877 48.2092 20.7137C48.2092 19.1396 46.9283 17.8588 45.3543 17.8588C43.7802 17.8588 42.4994 19.1397 42.4994 20.7137C42.4994 21.3878 41.9529 21.9341 41.279 21.9341C40.605 21.9341 40.0586 21.3877 40.0586 20.7137C40.0586 17.7937 42.4342 15.4181 45.3543 15.4181C48.2743 15.4181 50.6499 17.7937 50.6499 20.7137C50.6501 21.3877 50.1036 21.9341 49.4296 21.9341Z"
				fill="#3A79B9"
			/>
			<path
				d="M35.4057 47.2705C32.1726 47.2705 29.186 45.5143 27.6115 42.6875C27.2835 42.0987 27.495 41.3553 28.0838 41.0274C28.6725 40.6994 29.4158 40.911 29.7438 41.4997C30.8879 43.5538 33.0574 44.8296 35.4057 44.8296C37.6941 44.8296 39.8883 43.5408 41.132 41.4661C41.4787 40.8881 42.2283 40.7003 42.8063 41.0469C43.3845 41.3935 43.5721 42.1431 43.2255 42.7211C41.5432 45.5274 38.5468 47.2705 35.4057 47.2705Z"
				fill="#3A79B9"
			/>
		</svg>
	);
}

export default Calm;
